import type { UserRole } from './account'
import type { Culture } from './locale'
import type { BonusSelection } from './promotions'

export enum StorageType {
  Cookie = 'Cookie',
  LocalStorage = 'LocalStorage'
}

export interface LocaleCookieData {
  culture: Culture
}

export interface ImpersonationContext {
  isImpersonating: boolean
  impersonatedEmail?: string
  impersonatedRole?: UserRole
  agentEmail?: string
}

export interface CheckoutProperties {
  utmSource?: string
  utmMedium?: string
  utmCampaign?: string
  invoiceHash?: string
  recurlyToken?: string
  recurlyWants3DSecure?: boolean
  signifydSessionId?: string
  clientIpAddress?: string
  bonusSelections?: BonusSelection[]
  forfeitAcknowledged?: boolean
}

// No recursive objects, using JSON.stringify to serialize
export interface PersistentData {
  viewAsDate: string
  // used for testing portal dashboard with different comm periods
  demoViewAsDate: string
  sharedCartId: string
  units: 'imperial' | 'metric'
  pwa: boolean
  noTranslate: boolean
  pwaPrompt: boolean
  enabledFeature: string[]
  hybridRoute: string[]
  expirationDialogTime: number
  highlightDemo: boolean
  // One-shot marker naming the attribution param a session entered through, set
  // server-side before the strip-redirect and consumed once on the client to
  // tag the Clarity session. AB#63131
  demoReferral: string
  // used to validate whether user can context switch
  // user could be role customer and still have isDemo = true
  isDemo: boolean
  utm: CheckoutProperties
}

export type PersistentState = {
  [T in keyof PersistentData]: PersistentData[T] | null
}

export type PersistentStateStorage = {
  [T in keyof PersistentData]: StorageType
}
